import { createRoot } from 'react-dom/client';
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import * as Sentry from '@sentry/react';
import App from './components/App';
import './app.css';

// Initialize Sentry for error tracking
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Create HTTP link
const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'include',
});

// Create auth link to include CSRF token
const authLink = setContext((_, { headers }) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  return {
    headers: {
      ...headers,
      'X-CSRF-Token': token || '',
    }
  };
});

// Create Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      GradeLevelsSetting: {
        merge: true,
      },
      TuitionOptionsSetting: {
        merge: true,
      },
    },
  }),
});

// Initialize React app
const container = document.getElementById('app-root');
if (container) {
  const root = createRoot(container);
  root.render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
}
